import AButton from './index.vue';

AButton.install = app => {
  app.component(AButton.name, AButton);
};

export default AButton;
